import React from 'react';

const SUPPORTED_TYPES = ['text', 'email', 'search', 'password', 'number'];

const TextInput = React.forwardRef(function TextInput(
  {
    type,
    step,
    value,
    name,
    onChange,
    onBlur,
    className,
    placeholder,
    iconLeft,
    iconRight,
    validated,
    error,
    disabled,
    small,
    ...restProps
  },
  ref
) {
  if (!SUPPORTED_TYPES.includes(type)) {
    throw new Error(
      `type ${type} is not supported - must be any of: ${JSON.stringify(
        SUPPORTED_TYPES
      )}`
    );
  }

  const defaultClasses = `py-3 px-8 ${
    small ? '' : 'min-w-80'
  } rounded-full border-2 border-gray-300 focus:ring-0 focus-visible:ring-0 placeholder-gray-300 text-gray-800 ${
    validated || error || disabled
      ? ''
      : 'focus:border-gray-400 focus-visible:border-gray-400'
  }`;
  let stateClasses = '';

  if (validated) {
    stateClasses = 'border-primary focus:border-primary';
  }

  if (error) {
    stateClasses = 'border-secondary focus:border-secondary';
  }

  if (disabled) {
    stateClasses = 'bg-gray-100';
  }

  return (
    <div className="relative">
      {iconLeft && (
        <div className="absolute left-5 text-lg inset-y-0 text-gray-600 flex items-center">
          {iconLeft}
        </div>
      )}
      <input
        className={`form-input ${defaultClasses} ${stateClasses} ${
          className ? className : ''
        } ${iconRight ? 'pr-12' : ''} ${iconLeft ? 'pl-12' : ''}`}
        type={type}
        step={type === 'number' && step ? step : undefined}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={Boolean(disabled)}
        ref={ref}
        {...restProps}
      />
      {iconRight && (
        <div className="absolute right-5 text-lg inset-y-0 text-gray-600 flex items-center">
          {iconRight}
        </div>
      )}
    </div>
  );
});

export default TextInput;
